import React, { useCallback, useState, useEffect } from 'react';
import useCancellationToken from 'utils/customHook/useCancellationToken';
import GeneralCalendar from 'utils/calendar/GeneralCalendar';

const SearchDate = ({ title, dateValid, updateSearchMap, name }) => {
  const cancellationToken = useCancellationToken();
  const [ dateTime, setDateTime ] = useState({'date': new Date(), 'time': (name !== 'endDate') ? '00' : new Date().getHours() < 10 ? '0' + new Date().getHours().toString() : new Date().getHours().toString()}); 
  const updateDateTime = useCallback((key, value) => {
    setDateTime(dateTime => {
      return {
        ...dateTime, 
        [key]: value
      }
    });
  }, [])

  useEffect(() => {
    if (cancellationToken.isCancelled || !dateValid) {
      return
    }

    const date = dateTime.date;
    date.setHours(dateTime.time);
    updateSearchMap(name, date);
  }, [dateTime, cancellationToken, dateValid])

  useEffect(() => () => cancellationToken.cancel(), []);

  return (
    <div className="search-condition col-xl-4 col-sm-6">
      <label>{title}</label>
      <GeneralCalendar date={dateTime.date} 
                       updateDateFunction={updateDateTime}
                       name='date'
                       position={{right: '21', bottom: '-335'}} 
                       dateValid={dateValid} />
      <select className="table-search-input up-check"
              onChange={(({target}) => updateDateTime('time', target.value))}
              disabled={!dateValid}>
        {
          [...Array(25).keys()].map((v) => {
            return <option value={v} key={"start_" + v} selected={v === Number(dateTime.time) ? true :false}>{v < 10 ? "0" + v : v}시</option>
          })
        }
      </select>
    </div>
  )
}

export default React.memo(SearchDate);